import routes from './routes';
import $ from 'jquery';
import './App.css';

import { useRoutes } from 'react-router-dom'
import React, { useEffect } from 'react'

const App = () => {
  useEffect(() => {
    $(window).scrollTop(0)
  }, []);


  return (
    <div className="App">
      {useRoutes(routes)}

    </div>
  );
}

export default App;
